import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Button, DatePicker, Form, Input, InputNumber, Modal, Table, Pagination, Icon, Spin } from "antd";
import {getPlayers, getPlayerTopUp, getPlayerTopUpSuccess, topUpPlayer} from '../../actions/PlayersAction';
import { getPermissions } from "../../actions/AffiliateActions";
import moment from 'moment';
import {Utils} from "../../services/Utlis";

class Players extends React.Component {
  state = {
    RegistrationStartValue: null,
    RegistrationEndValue: null,
    LoginStartValue: null,
    LoginEndValue: null,
    playerId: null,
    email: null,
    endOpen: false,
    topUpModal: { visible: false },
    balance: 0,
    pageNumber: 1
  };

  componentDidMount() {
    const { affiliateId } = this.props.affiliates;
    const { pageNumber } = this.state;

    this.props.dispatch(getPlayers(affiliateId, pageNumber));
    this.props.dispatch(getPermissions(affiliateId, true));
  }

  onPageChange = (current) => {
    this.setState({ pageNumber: current });
  }

  // On page and affiliate change get new data
  componentDidUpdate(prevProps, prevState) {
    let { affiliateId } = this.props.affiliates;
    const { pageNumber } = this.state;
    const { email, id, LoginEndValue, LoginStartValue, RegistrationEndValue, RegistrationStartValue } = this.state;

    if (prevState.pageNumber !== pageNumber) {
      this.props.dispatch(getPlayers(affiliateId, pageNumber, {
        playerId: id,
        email,
        lastLoginDate: LoginStartValue && moment.utc(LoginStartValue).format(),
        lastLoginEndDate: LoginEndValue && moment.utc(LoginEndValue).format(),
        registrationEndDate: RegistrationEndValue && moment.utc(RegistrationEndValue).format(),
        registrationStartDate: RegistrationStartValue && moment.utc(RegistrationStartValue).format(),
      }));
    }

    if (prevProps.affiliates.affiliateId !== affiliateId) {
      window.location.reload(false);
      // this.props.dispatch(getPlayers(affiliateId, pageNumber));
    }
  }

  disabledRegistrationStartDate = RegistrationStartValue => {
    const { RegistrationEndValue } = this.state;
    if (!RegistrationStartValue || !RegistrationEndValue) {
      return false;
    }
    return RegistrationStartValue.valueOf() > RegistrationEndValue.valueOf();
  };

  disabledRegistrationEndDate = RegistrationEndValue => {
    const { RegistrationStartValue } = this.state;
    if (!RegistrationEndValue || !RegistrationStartValue) {
      return false;
    }
    return RegistrationEndValue.valueOf() <= RegistrationStartValue.valueOf();
  };

  disabledLoginStartDate = LoginStartValue => {
    const { LoginEndValue } = this.state;
    if (!LoginStartValue || !LoginEndValue) {
      return false;
    }
    return LoginStartValue.valueOf() > LoginEndValue.valueOf();
  };

  disabledLoginEndDate = LoginEndValue => {
    const { LoginStartValue } = this.state;
    if (!LoginEndValue || !LoginStartValue) {
      return false;
    }
    return LoginEndValue.valueOf() <= LoginStartValue.valueOf();
  };

  onChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  onRegistrationStartChange = value => {
    this.onChange('RegistrationStartValue', value);
  };

  onRegistrationEndChange = value => {
    this.onChange('RegistrationEndValue', value);
  };

  onLoginStartChange = value => {
    this.onChange('LoginStartValue', value);
  };

  onLoginEndChange = value => {
    this.onChange('LoginEndValue', value);
  };

  handleStartOpenChange = open => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  };

  handleModalCancel = () => {
    this.setState({
      topUpModal: { visible: false }
    });
    this.props.dispatch(getPlayerTopUpSuccess({Data: null}))
  };

  showTopUpModal = (event, row, index) => {
    this.props.dispatch(getPlayerTopUp(this.props.affiliates.affiliateId));
    this.setState({
      topUpModal: { visible: true, row: row },
      balance: row.balance
    })
  };

  onSaveTopUp = (row) => {
    const { form } = this.props;
    const { pageNumber } = this.state;
    const { affiliateId } = this.props.affiliates;

    form.validateFields((err, values) => {
      if (!err) {
        const formData = {
          playerId: row.id,
          amount: values.amount
        }

        this.props.dispatch(topUpPlayer(formData, affiliateId)).then(() => {
          this.props.dispatch(getPlayers(affiliateId, pageNumber))
        });

        this.handleModalCancel();
      }
    })
  };

  handleFilterPlayer = () => {
    const { form } = this.props;
    const { affiliateId } = this.props.affiliates

    this.onPageChange(1);

    form.validateFields((err, values) => {
      if (!err) {
        const { id, email, lastLoginDate, lastLoginEndDate, registrationEndDate, registrationStartDate } = values;

        this.setState({
          email: values.email,
          playerId: values.playerId
        });
        this.props.dispatch(getPlayers(affiliateId, 1, {
          playerId: id,
          email,
          lastLoginDate: lastLoginDate && lastLoginDate.format(),
          lastLoginEndDate: lastLoginEndDate && lastLoginEndDate.format(),
          registrationEndDate: registrationEndDate && registrationEndDate.format(),
          registrationStartDate: registrationStartDate && registrationStartDate.format(),
        }))
      }
      // form.resetFields();
    })
  };

  onKeyPress(event) {
    const keyCode = event.keyCode || event.which;
    if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 96 && keyCode <= 105) && keyCode !== 8) { 
      event.preventDefault();
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { players } = this.props.players;
    const { permissions } = this.props.affiliates;

    const sorter = (a, b) => {
      if (a.id < b.id) { return -1; }
      if (a.id > b.id) { return 1; }
      return 0;
    };

    const columns = [
      {
        title: this.props.intl.messages.id,
        dataIndex: 'id',
        key: 'id',
        filters: [],
        sorter: sorter,
        sortDirections: ['ascend' , 'descend'],
      },
      {
        title: this.props.intl.messages.email,
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: this.props.intl.messages.registered,
        dataIndex: 'registrationDate',
        key: 'registrationDate',
      },
      {
        title: this.props.intl.messages.last_login,
        dataIndex: 'lastLoginDate',
        key: 'lastLoginDate',
      },
      {
        title: this.props.intl.messages.balance,
        dataIndex: 'balance',
        key: 'balance',
        render: balance => Utils.numberWithCommas(balance)
      },
      {
        title: '',
        dataIndex: 'topUp',
        key: 'topUp',
        render: (value, row, index) => permissions && permissions.includes('TopupPlayers') && <Button className="ta--f-12 ta--topUp_btn" type="primary" onClick={(e) => this.showTopUpModal(e, row, index)}>{this.props.intl.messages.top_up}</Button>,
      },
    ];

    const antIcon = <Icon type="loading" className="ta--ant_loader" spin />;

    let tableData = [];
    if (players && players.Players) {
      tableData = Object.keys(players.Players).map(key => {
        return {
          id: players.Players[key].Id,
          key: players.Players[key].Id,
          email: players.Players[key].Email,
          registrationDate: players.Players[key].RegistrationDate && moment(players.Players[key].RegistrationDate).format("DD/MM/YYYY HH:mm"),
          lastLoginDate: players.Players[key].LastLoginDate && moment(players.Players[key].LastLoginDate).format("DD/MM/YYYY HH:mm"),
          balance: players.Players[key].Balance,
        }
      }).sort(this.sorter);
    }

    return (
      <div>
        <h2 className='ta--main-header'>{this.props.intl.messages.players}</h2>

        <div className='ta--flex ta--players-filter'>
          <Form layout="vertical" className='ta--flex ta--align-center ta-flex-grid ta-w100 '>

            <Form.Item label={this.props.intl.messages.id} className='ta--flex-grid__item'>
              {getFieldDecorator('id')(
                <InputNumber onKeyDown={this.onKeyPress} placeholder={this.props.intl.messages.type_here} />
              )}
            </Form.Item>

            <Form.Item label={this.props.intl.messages.email} className='ta--flex-grid__item'>
              {getFieldDecorator('email')(
                <Input placeholder={this.props.intl.messages.type_here} />
              )}
            </Form.Item>

            <Form.Item label={this.props.intl.messages.register_start} className='ta--flex-grid__item'>
              {getFieldDecorator('registrationStartDate')(
                <DatePicker
                  disabledDate={this.disabledRegistrationStartDate}
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder={this.props.intl.messages.start_date}
                  onChange={this.onRegistrationStartChange}
                  onOpenChange={this.handleStartOpenChange}
                />)}
            </Form.Item>

            <Form.Item label={this.props.intl.messages.register_end} className='ta--flex-grid__item'>
              {getFieldDecorator('registrationEndDate')(
                <DatePicker
                  disabledDate={this.disabledRegistrationEndDate}
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder={this.props.intl.messages.end_date}
                  onChange={this.onRegistrationEndChange}
                  onOpenChange={this.handleStartOpenChange}
                />)}
            </Form.Item>

            <Form.Item label={this.props.intl.messages.login_start_date} className='ta--flex-grid__item'>
              {getFieldDecorator('lastLoginDate')(
                <DatePicker
                  disabledDate={this.disabledLoginStartDate}
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder={this.props.intl.messages.start_date}
                  onChange={this.onLoginStartChange}
                  onOpenChange={this.handleStartOpenChange}
                />)}
            </Form.Item>

            <Form.Item label={this.props.intl.messages.login_end_date} className='ta--flex-grid__item'>
              {getFieldDecorator('lastLoginEndDate')(
                <DatePicker
                  disabledDate={this.disabledLoginEndDate}
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder={this.props.intl.messages.end_date}
                  onChange={this.onLoginEndChange}
                  onOpenChange={this.handleStartOpenChange}
                />)}
            </Form.Item>

            <Button onClick={this.handleFilterPlayer} className='ta--mb-4 ta--mt-24 ta--ml-auto' key="done" type="primary">{this.props.intl.messages.filter}</Button>
          </Form>
        </div>

        <Spin indicator={antIcon} spinning={this.props.players.inProcess}>
          <Table
            dataSource={tableData.sort(sorter)}
            columns={columns}
            pagination={false}
            className="ta-aff-table ta--mt-8"
            footer={() => <div className='ta--flex ta--justify-between rtl--row-reverse'>
              <div className='ta--total-rows'>{this.props.intl.messages.total_rows}: {players && players.RowCount}</div>
              <div>{this.props.intl.messages.summary}: <span className='ta--green ta--fw-b'>{players && Utils.numberWithCommas(players.TotalAmount)}</span></div>
            </div>}
          >
          </Table>
          <Pagination current={this.state.pageNumber} pageSize={13} total={players && players.RowCount} onChange={this.onPageChange} />
        </Spin>

        {this.state.topUpModal.visible &&
          <Modal
            title={this.props.intl.messages.top_up}
            visible={this.state.topUpModal.visible}
            centered
            onCancel={this.handleModalCancel}

            footer={[
              <React.Fragment>
                <Button onClick={this.handleModalCancel} key="cancel">{this.props.intl.messages.cancel}</Button>
                <Button onClick={() => this.onSaveTopUp(this.state.topUpModal.row)} key="top_up" type="primary" >{this.props.intl.messages.top_up}</Button>
              </React.Fragment>
            ]}
          >
            <Form>
              <Form.Item label={this.props.intl.messages.balance}>
                <Input placeholder={this.props.players.playerBalance} autoComplete="off" disabled />
              </Form.Item>

              <Form.Item label={this.props.intl.messages.amount}>
                {getFieldDecorator('amount', {
                  rules: [{
                    required: true,
                    message: this.props.intl.messages.required_field
                  }],
                })(
                  <Input placeholder="100" autoComplete="off" maxLength={50} />
                )}
              </Form.Item>
            </Form>
          </Modal>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    players: state.players,
    affiliates: state.affiliates,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return ({
    dispatch
  })
}

export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(Players)));


// WEBPACK FOOTER //
// ./src/routes/subAffilate/Players.js